import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { kpi, sla, filecontent } from './../../../models/slakpi';
import { division, user, department, targetMaster } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import { AngularEditorConfig } from '@kolkov/angular-editor';

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.css']

})
export class KPIComponent implements OnInit {
  showMyContainer: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public selTab2 = false;
  public selTab3 = false;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public kpiTypeUno_data: any;
  public target_data: any;
  public trend_data: any;
  public ddType_data: any
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;
  public frequency_data: any;
  public selected_kpiCode: string = '';
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public orderData: object;
  public kpiData: object[];
  public kpiForm: FormGroup;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public uploadedFiles: Array<File> = [];
  isShow = false;
  isBenchMark: boolean = false;
  isHasBudget: boolean = false;
  KPIUno: string;
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
  public value_inpdataEntryUno: number[];
  public value_level1ApproverUno: number[];
  public value_level2ApproverUno: number[];
  public value_level3ApproverUno: number[];

  public permission: number = 1;
  public divisionUno_filter: number = 0;
  public checkbox_filter: boolean = false;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  objKPI: any = new kpi();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter

  public sli_data: any;

  public slaUnofilter?: number = 0;
  public divisionUnofilter?: number = 0;
  public divisionUnoSecondaryfilter?: number = 0;
  public frequencyUnofilter?: number = 0;
  public isStart: boolean = true;
  public isToggle: boolean = true;
  public isDynamicEntry: string = 'false';
  public selectedfrequencyUno: number;
  editorConfig: AngularEditorConfig;
  public uniqueData: any;
  public masterData: any;
  public filterOption: any;
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  isDigitalDewa: boolean = false;
  isInternalAudit: boolean = false;
    finaldata: any;
  constructor(private formBuilder: FormBuilder, public restApi: SLAKPIApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.isDynamicEntry = this.user.isDynamicEntry;
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;

    this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    } else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;

    }

  }



  ngOnInit() {
    
    this.userService.CheckLogin();

    this.editorConfig = {
      editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        { class: 'arial', name: 'Arial' },
        { class: 'times-new-roman', name: 'Times New Roman' },
        { class: 'calibri', name: 'Calibri' },
        { class: 'comic-sans-ms', name: 'Comic Sans MS' }
      ],
      customClasses: [
        {
          name: 'quote',
          class: 'quote',
        },
        {
          name: 'redText',
          class: 'redText'
        },
        {
          name: 'titleText',
          class: 'titleText',
          tag: 'h1',
        },
      ],
      uploadUrl: 'v1/image',
      uploadWithCredentials: false,
      sanitize: true,
      toolbarPosition: 'top',
      toolbarHiddenButtons: [
        ['bold', 'italic'],
        ['fontSize']
      ]
    };
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [500,1000,1500,2000,2500,3000],
        pageSize: 2000
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      //enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.loadKPI();
    this.getDivisions();
    this.getDepartments();
    this.getTarget();
    this.getTrend();
    this.getDDType();
    this.getslaStatusRule();
    this.getCondition();
    this.getFrequency();

    //this.loadFrequency();
    this.getUsers();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA KPIs");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.trendName && a.trendName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetName && a.targetName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaRuleName && a.slaRuleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.scheduleName && a.scheduleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.report && a.report.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    if (!this.isInternalAudit) {
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'trendName', name: 'Direction', field: 'trendName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'trendName', 'trendName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'targetName', name: 'Methodology', field: 'targetName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'targetName', 'targetName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', selectable: false, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'scheduleName', name: 'Frequency', field: 'scheduleName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'scheduleName', 'scheduleName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'report', name: 'Reporting Division', field: 'reportingDivisionName', width: 100, sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'reportingDivisionName', 'reportingDivisionName'),
            model: Filters.multipleSelect,
          },
        },
        {
          id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
          excludeFromExport: true,
          formatter: this.actionFormatter,
          cellMenu: {
            hideCloseButton: false,
            commandTitleKey: 'COMMANDS',
            commandItems: [
              {
                command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
                //itemVisibilityOverride: (args: MenuCallbackArgs) => {
                //  let data = args.dataContext;

                //  if (this.isInternalAudit)
                //    return false;
                //  else return true;
                //},
                iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',

                action: (e, args) => {
                  this.pageAction = 'edit';
                  this.selectedfrequencyUno = 0;
                  
                  if (this.permission == 1) {
                    let rdata: any = args.dataContext;
                    this.selTab = true;
                    this.selTab2 = false;
                    this.selTab3 = false;
                    this.selected_kpiCode = rdata.kpiCode;
                    this.KPIUno = rdata.kpiUno;
                    this.getFiles(this.KPIUno);
                    this.objKPI = rdata;//this.kpiData.filter((items: any) => items.kpiUno == rdata.kpiUno)[0];
                    this.objKPI.dataOwnerUno = (this.objKPI.dataOwnerUno) ? this.utilityService.CommaSeperatorToArray(this.objKPI.dataOwnerUno.toString()) : [];
                    this.objKPI.level1ApproverUno = (this.objKPI.level1ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objKPI.level1ApproverUno.toString()) : [];
                    this.objKPI.level2ApproverUno = (this.objKPI.level2ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objKPI.level2ApproverUno.toString()) : [];
                    this.objKPI.level3ApproverUno = (this.objKPI.level3ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objKPI.level3ApproverUno.toString()) : [];
                    
                    if (this.pageAction == 'edit') {
                      
                      this.selectedfrequencyUno = rdata.slaRuleUno;
                      let divisionUno = (rdata.businessDivisionUno != null && rdata.businessDivisionUno != '') ? rdata.businessDivisionUno : 0;
                      if (this.checkbox_filter) {
                        this.user_data_filter = this.user_data.filter(
                          user => user.divisionUno === divisionUno);
                        this.dataEntry_data_filter = this.dataEntry_data.filter(
                          user => user.divisionUno === divisionUno);
                      }
                    }
                    this.uploadedFiles = [];
                    this.modalRef = this.modalService.show(
                      this.addtemplate,
                      Object.assign({}, {
                        class: 'gray modal-xl modal-full',
                        backdrop: true,
                        keyboard: true,
                        focus: true,
                        show: false,
                        ignoreBackdropClick: true,
                        animated: true
                      })
                    );
                  }
                },
                // only show command to 'Delete Row' when the task is not completed

              },
              { divider: true, command: '', positionOrder: 63 },
              {
                command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
                //itemVisibilityOverride: (args: MenuCallbackArgs) => {
                //  let data = args.dataContext;

                //  if (this.isInternalAudit)
                //    return false;
                //  else return true;
                //},
                iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
                action: (e, args) => {
                  Swal.fire({
                    title: 'Delete',
                    text: 'Please confirm to delete the record',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result) => {
                    if (result.value) {
                      this.pageAction = 'delete';
                      this.DeleteKPI(args.dataContext);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {

                    }
                  })
                },
                // only show command to 'Delete Row' when the task is not completed

              },


            ],
          }
        }




      ]
    } else {
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'trendName', name: 'Direction', field: 'trendName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'trendName', 'trendName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'targetName', name: 'Methodology', field: 'targetName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'targetName', 'targetName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', selectable: false, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'scheduleName', name: 'Frequency', field: 'scheduleName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'scheduleName', 'scheduleName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'report', name: 'Reporting Division', field: 'reportingDivisionName', width: 100, sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'reportingDivisionName', 'reportingDivisionName'),
            model: Filters.multipleSelect,
          },
        },
      




      ]
}
    


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };


  // Get kpi list
  loadKPI() {
    this.loading = true;
    
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    //inpValue.frequencyUno = this.frequencyUnofilter ? this.frequencyUnofilter : 0;
    //inpValue.slaRuleUno = this.slaUnofilter ? this.slaUnofilter : 0;
    //inpValue.businessDivisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    //inpValue.reportingDivisionUno = (this.divisionUnoSecondaryfilter) ? this.divisionUnoSecondaryfilter : 0;

    inpValue.frequencyUno =  0;
    inpValue.slaRuleUno =  0;
    inpValue.businessDivisionUno =  0;
    inpValue.reportingDivisionUno =  0;
    
    this.restApi.getKPIs(inpValue)
      .subscribe(data => {
        
        this.data = [];
        this.data = uniqBy(data, 'kpiUno');


        const mockDataset = [];

        //for (let i = 0; i < this.data.length; i++) {
        //  mockDataset[i] = {
        //    id: this.data[i].kpiUno,
        //    kpiCode: this.data[i].kpiCode,
        //    kpiNameEn: this.data[i].kpiNameEn,
        //    trendName: this.data[i].trendName,
        //    targetName: this.data[i].targetName,
        //    slaRuleName: this.data[i].slaRuleName,
        //    scheduleName: this.data[i].scheduleName,
        //    reportingDivisionName: this.data[i].reportingDivisionName
        //  };
        //}
       // this.data = this.data.slice(0, 10);

        //this.dataset = this.data.slice(0, 100);//mockDataset;
        //this.dataSearch = this.data.slice(0, 100);//mockDataset;
        //if (this.data.slice(0, 100).length > 0) {
          this.setColnDefn();
        //}
        this.kpiData = this.data;
        this.isStart = false;
        this.loading = false;
        
        this.dataset = this.data;
        this.dataSearch = this.data;

        

        //Load More
        if (this.dataset.length >= 100) {
          
          let loadallKPI = new Promise((resolve, reject) => {
            setTimeout(() => {
              this.loadKPI_More();
              resolve('LOAD All');
            }, 1000);

          });

          try {
            let result = Promise.all([loadallKPI]);
            result.then(data => console.log(data));
          } catch (error) {
            console.log(error);
          }
        }

      },
        (error) => {
          //Called when error
          //this.spinner.hide();
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  // Get kpi list
  loadKPI_More() {
    //this.loading = true;

    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 11;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.frequencyUno = this.frequencyUnofilter ? this.frequencyUnofilter : 0;
    inpValue.slaRuleUno = this.slaUnofilter ? this.slaUnofilter : 0;
    inpValue.businessDivisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.reportingDivisionUno = (this.divisionUnoSecondaryfilter) ? this.divisionUnoSecondaryfilter : 0;
    
    this.restApi.getKPIs(inpValue)
      .subscribe(data => {
        
        this.data = uniqBy(data, 'kpiUno');


        
        this.setColnDefn();
        
        this.kpiData = this.data;
        this.isStart = false;
        this.loading = false;
        this.dataset = this.data;
        this.dataSearch = this.data;

        this.finaldata = this.data;
      },
        (error) => {
          //Called when error
          //this.spinner.hide();
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        //let rtnData:any = data;
        //if (rtnData.data.length > 0) {
        //  this.division_data = rtnData.data;
        //}
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {

        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTarget() {

    let inpValue = new targetMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.GetTargetInfo(inpValue)
      .subscribe(data => {

        this.target_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTrend() {
    this.trend_data = [
      { trendUno: 1, trendName: 'Positive' },
      { trendUno: 2, trendName: 'Negative' }
    ];
  }
  getDDType() {
    this.ddType_data = [
      { ddTypeUno: 1, ddTypeName: 'Profit' },
      { ddTypeUno: 2, ddTypeName: 'Revenue' },
      { ddTypeUno: 3, ddTypeName: 'Expenses' },
      { ddTypeUno: 4, ddTypeName: 'Net Result' },
      { ddTypeUno: 5, ddTypeName: 'EBITDA' }
    ];
  }
  getslaStatusRule() {
    this.slaStatusRule_data = [
      { slaStatusRuleUno: 1, slaStatusRuleName: 'Range' },
      { slaStatusRuleUno: 2, slaStatusRuleName: 'Variance' },
      { slaStatusRuleUno: 3, slaStatusRuleName: '0 - Target' },
      { slaStatusRuleUno: 4, slaStatusRuleName: 'Text' }
    ];
  }
  getCondition() {
    this.condition2_data = [
      { text: '>', value: '>' },
      { text: '>=', value: '>=' },
      { text: '=', value: '=' },
      { text: '<', value: '<' },
      { text: '<=', value: '<=' }
    ];
  }

  getFrequency() {
    
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
    
  }

  getUsers() {

    let inpValue = new user();
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }




  AddEditKPI(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}
    if (data1.slaRuleUno == 0) {
      this.toaster.show('error', 'Error', 'Choose KPI Type');
      return false;
    }
    if (data1.frequencyUno == 0) {
      this.toaster.show('error', 'Error', 'Choose Frequency');
      return false;
    }
    //if (this.DuplicateNameCheck(this.utilityService.isStringNull(data1.kpiCode), this.utilityService.isNumericNull(data1.kpiUno), this.utilityService.isStringNull(data1.kpiNameEn), this.utilityService.isStringNull(data1.kpiNameAr))) {
    //  // Swal.fire('Error', 'Duplicates are not allowed', 'warning');
    //  this.toaster.show('error', 'Error', 'Duplicates are not allowed');
    //  return false;
    //}
    //else {

      let objKPI = new kpi();
      objKPI = data1
      objKPI.dataOwnerUno = (objKPI.dataOwnerUno) ? objKPI.dataOwnerUno.toString() : '';
      objKPI.level1ApproverUno = (objKPI.level1ApproverUno) ? objKPI.level1ApproverUno.toString() : '';
      objKPI.level2ApproverUno = (objKPI.level2ApproverUno) ? objKPI.level2ApproverUno.toString() : '';
      objKPI.level3ApproverUno = (objKPI.level3ApproverUno) ? objKPI.level3ApproverUno.toString() : '';
      objKPI.actionType = this.pageAction;
      objKPI.kpiUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.kpiUno);

      objKPI.slaUno = 1;

      objKPI.userUno = this.login_UserID;
      objKPI.condition = (this.pageAction == "add") ? 0 : 1;
      objKPI.tenantUno = this.tenantUno;
      objKPI.benchMarked = this.isBenchMark;
      objKPI.hasBudget = this.isHasBudget;
      objKPI.ddTypeUno = (objKPI.ddTypeUno) ? objKPI.ddTypeUno:0;
      this.restApi.addEditKPI(objKPI)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
            //  //Swal.fire('Error', 'Something went wrong', 'error');
            //  this.toaster.show('error', 'Error', 'Something went wrong');
            //  this.spinner.hide();
            //}
            //else {
            //  //Swal.fire({
            //  //  type: 'success',
            //  //  title: 'KPI saved.',
            //  //  showConfirmButton: false,
            //  //  timer: 1500
            //  //})
            if (data == '999') {
              this.toaster.show('error', 'Error', 'Duplicates are not allowed');
            } else {
              this.toaster.show('success', 'Success', 'KPI saved.');
              this.KPIUno = (this.pageAction == "add") ? data.toString() : this.KPIUno;
              this.modalRef.hide();
              this.uploadFiles();
              setTimeout(() => { this.spinner.hide(); this.loadKPI(); }, 900);
            }
            

          }
          //else {

          //  this.toaster.show('error', 'Error', 'Something went wrong');
          //  this.modalRef.hide();
          //}



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return false;
    //}
  }
 
  DuplicateNameCheck(kpiCode: string, kpiUno: number, kpiNameEn: string, kpiNameAr: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {


        //if (((kpiUno != grdData.kpiUno) || (kpiUno == grdData.kpiUno && this.selected_kpiCode != grdData.kpiCode))
        //  &&
        //  (grdData.kpiCode.trim().toLowerCase() + grdData.kpiNameEn.toLocaleLowerCase() == kpiCode.trim().toLowerCase() + kpiNameEn.toLocaleLowerCase())) {
        //  rtnValue = true;
        //}


        if ((kpiUno != grdData.kpiUno)
          &&
          (grdData.kpiCode.trim().toLowerCase() + grdData.kpiNameEn.toLocaleLowerCase() == kpiCode.trim().toLowerCase() + kpiNameEn.toLocaleLowerCase())) {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }


  DeleteKPI(data1: any) {

    let objDeaprtment = new kpi();
    objDeaprtment.actionType = this.pageAction;
    objDeaprtment.kpiUno = data1.kpiUno;
    objDeaprtment.userUno = this.login_UserID;
    objDeaprtment.tenantUno = this.tenantUno;

    this.restApi.deleteKPI(objDeaprtment)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI deleted.');
          this.loadKPI();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }


  onfilterData(ev: any) {
    
    this.objKPI.dataOwnerUno = [];
    this.objKPI.level1ApproverUno = [];
    this.objKPI.level2ApproverUno = [];
    this.objKPI.level3ApproverUno = [];

    if (ev.currentTarget.checked) {
      this.user_data_filter = this.user_data.filter(
        user => user.divisionUno === this.divisionUno_filter);
      this.dataEntry_data_filter = this.dataEntry_data.filter(
        user => user.divisionUno === this.divisionUno_filter);
      this.checkbox_filter = true;
    }
    else {
      this.user_data_filter = this.user_data;
      this.dataEntry_data_filter = this.user_data;
      this.checkbox_filter = false;

    }
  }

  onBenchMarchData(ev: any) {
    

    if (ev.currentTarget.checked) {
      this.isBenchMark = true;
    }
    else {
      this.isBenchMark = false;

    }
  }

  onHasbudgetChange(ev: any) {
    if (ev.currentTarget.checked) {
      this.isHasBudget = true;
    }
    else {
      this.isHasBudget = false;

    }
  }
  onchangeDivision(e) {

    // this.AutoCompleteObj.value = "";
    // this.level1ApproverUno. = "";
    this.value_inpdataEntryUno = [];
    this.value_level1ApproverUno = [];
    this.value_level2ApproverUno = [];
    this.value_level3ApproverUno = [];
    let divisionUno = (e.itemData != null && e.itemData.divisionUno != null && e.itemData.divisionUno != '') ? e.itemData.divisionUno : 0;
    this.divisionUno_filter = divisionUno;
    if (this.checkbox_filter) {
      this.user_data_filter = this.user_data.filter(
        user => user.divisionUno === divisionUno);
      this.dataEntry_data_filter = this.dataEntry_data.filter(
        user => user.divisionUno === divisionUno);
    } else { this.user_data_filter = this.user_data; }

  }




  //loadFrequency() {
  //  this.frequency_data = [
  //    { frequencyCode: 1, frequencyName: 'Yearly' },
  //    { frequencyCode: 2, frequencyName: 'Semi-annually' },
  //    { frequencyCode: 3, frequencyName: 'Quarterly' }
  //  ];
  //}


  // Choose city using select dropdown
  searchSLA() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () {

        temp.loadKPI();

      }, 1000)

    }
  }
  //searchSLA(item:any) {

  //  if (item == 'rule') {
  //    if (this.slaUnofilter > 0)
  //    this.dataset = this.finaldata.filter(a => a.slaRuleUno == this.slaUnofilter);

  //  }
  //  if (item == 'frequencyUno') {
  //    if()
  //    this.dataset = this.dataSearch.filter(a => a.frequencyUno == this.frequencyUnofilter);

  //  }
  //  if (item == 'businessDivisionUno') {
  //    this.dataset = this.dataSearch.filter(a => a.businessDivisionUno == '');

  //  }

  //  if (item == 'reportingDivisionUno') {
  //    this.dataset = this.dataSearch.filter(a => a.reportingDivisionUno == '');

  //  }
  //}

  //inpValue.frequencyUno = this.frequencyUnofilter ? this.frequencyUnofilter : 0;
    //inpValue.slaRuleUno = this.slaUnofilter ? this.slaUnofilter : 0;
    //inpValue.businessDivisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    //inpValue.reportingDivisionUno = (this.divisionUnoSecondaryfilter) ? this.divisionUnoSecondaryfilter : 0;



  onChangeFreq(args): void {
    
    this.selectedfrequencyUno = args.value;
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.pageAction = "add";
    this.objKPI = new kpi();
    this.selTab = true;
    this.selTab2 = false;
    this.selTab3 = false;
    this.uploadedFiles = [];
    this.AttachmentList = [];
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-xl modal-full',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }


  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }

  onChangeTab(selectedTab: any) {
    if (selectedTab == 'general') {
      this.selTab = true;
      this.selTab2 = false;
      this.selTab3 = false;

    }
    else if (selectedTab == 'accountability') {
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;

    }
    else if (selectedTab == 'suervey') {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = true;

    }
    return false;
  }
  onNext(val) {
    if (val) {
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;
    }
    else {
      // Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('error', 'Error', 'Please enter the General Information.');
    }
  }

  onNextAcc(val) {
    
    if (val) {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = true;
    }
    else {
      // Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('error', 'Error', 'Please enter the Accountability Information.');
    }
  }
  onSubmit(val1, val2) {
    
    if (!val1 && !val2) {
      // Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');

      return
    }
    else if (!val1) {
      //Swal.fire('Error', 'Please enter the Accountability Information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the Accountability Information.');
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;
      return
    }
    else if (!val2) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the General Information.');
      this.selTab = true;
      this.selTab2 = false;
      this.selTab3 = false;
    }
    else {
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        //Check file count 
        if (this.uploadedFiles.length > 5) {
          this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload.');
          return false;
        }

        for (var i = 0; i < this.uploadedFiles.length; i++) {
          let fileName = this.uploadedFiles[i].name.toLowerCase();
          let fileSize = this.uploadedFiles[i].size;
          //Check file size
          if (!this.userService.checkFileSize(fileSize)) {
            this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
            return false;
          }
          //To check file exe
          if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
            this.toaster.show('error', 'Error', 'Please select the correct format file.');
            return false;
          }
        }
      }
      this.AddEditKPI(this.objKPI)
    }
  }
  getFiles(kpiUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = kpiUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.KPIUno = kpiUno;
    this.restApi.KPI_FileSelect(inpValue)
      .subscribe(data => {
        
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  DeleteAttachment(itemUno: string) {

    //});
    
    let inpValue = new filecontent();
    inpValue.masterUNo = this.KPIUno;
    inpValue.itemUNo = itemUno;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.KPI_FileDelete(inpValue)
      .subscribe(data => {
        this.getFiles(this.KPIUno);
        //setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.KPIUno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.KPI_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }
  uploadFiles() {
    this.spinner.show();
    
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();

      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);
      
      if (allowFile) {
        this.restApi.KPIFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, this.KPIUno).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }
  }
 

  onChageFormula() {
    

    let formula = this.objKPI.formula;
    if (formula != null && formula != '') {
      if (formula.toLowerCase() == "na" || formula.toLowerCase() == "n/a") {
        this.objKPI.unitEn = 'NA';
        this.objKPI.unitAr = 'NA';
      }
      else {
        this.objKPI.unitEn = '';
        this.objKPI.unitAr = '';
      }
    }

    return false;
  }
}
